import { useMemo } from "react";
import ReactTooltip from "react-tooltip";
import momentTimezone from "moment-timezone";
import NoDataComponent from "./../../../../components/Table/TableComponents/NoDataComponent";
import PopupMenu from "../../../SimpleForm/PopupMenu/index.js";
import { ReactTable } from "../../../SimpleForm/ReactTable/index.js";
import "./CaseDocumentsTable.scss";

const contentStyle = {
  width: "350px",
  boxShadow: "inset 0px 4px 0px 0px #AEB0B5, 0 2px 6px 0 rgba(0,0,0,0.5)",
  padding: "0",
  paddingTop: "4px",
  border: "none",
};

const arrowStyle = {
  width: "0",
  height: "0",
  borderStyle: "solid",
  borderWidth: "0 0 13px 13px",
  outline: "none",
  borderColor: "transparent transparent #AEB0B5 transparent",
  background: "transparent",
  boxShadow: "none",
};

function BasicCell({ value, tooltipId }) {
  return (
    <>
      <span data-tip data-for={tooltipId}>
        {value ?? "--"}
      </span>
      <ReactTooltip type="dark" effect="solid" id={tooltipId}>
        <span>{value ?? "--"}</span>
      </ReactTooltip>
    </>
  );
}

function PopupCell({ docs }) {
  return (
    <>
      <PopupMenu
        contentStyle={contentStyle}
        arrowStyle={arrowStyle}
        trigger={<span className="hoverable">View Documents</span>}
        position="bottom right"
        on={["hover", "focus"]}
      >
        <div>
          <ul>
            {docs.map((doc, i) => {
              const style =
                i !== docs.length - 1
                  ? { paddingBottom: "10px" }
                  : { paddingBottom: "0px" };
              return (
                <li key={i} style={style}>
                  {doc}
                </li>
              );
            })}
          </ul>
        </div>
      </PopupMenu>
    </>
  );
}

function NoData(props) {
  return <NoDataComponent noDataResult="There is no data for " {...props} />;
}

function CaseRecordsTable({ records }) {
  const columns = useMemo(
    () => [
      {
        Header: "Date Submitted",
        accessor: "timestamp",
        id: "timestamp",
        fixedWidth: 165,
        Cell: ({ cell: { value }, row: { index }, column: { id } }) => {
          const tooltipId = `${id}_${index}`;
          const _date = momentTimezone(value)
            .tz("America/New_York")
            .format("LL");
          return <BasicCell value={_date} tooltipId={tooltipId} />;
        },
      },
      {
        Header: "Action Type",
        accessor: "action",
        id: "action",
        Cell: ({ cell: { value }, row: { index }, column: { id } }) => {
          const tooltipId = `${id}_${index}`;
          return <BasicCell value={value} tooltipId={tooltipId} />;
        },
      },
      {
        Header: "External Status",
        accessor: "externalStatus",
        id: "externalStatus",
        Cell: ({ cell: { value }, row: { index }, column: { id } }) => {
          const tooltipId = `${id}_${index}`;
          return <BasicCell value={value} tooltipId={tooltipId} />;
        },
      },
      {
        Header: "Email",
        accessor: "email",
        id: "email",
        Cell: ({ cell: { value }, row: { index }, column: { id } }) => {
          const tooltipId = `${id}_${index}`;
          return <BasicCell value={value} tooltipId={tooltipId} />;
        },
      },
      {
        Header: "External Filer Name",
        accessor: "actorName",
        id: "actorName",
        Cell: ({ cell: { value }, row: { index }, column: { id } }) => {
          const tooltipId = `${id}_${index}`;
          return <BasicCell value={value} tooltipId={tooltipId} />;
        },
      },
      {
        Header: "Document(s)",
        accessor: "docs",
        id: "docs",
        isSorted: "false",
        type: "popover",
        Cell: ({ cell: { value }, row: { index }, column: { id } }) => {
          const tooltipId = `${id}_${index}`;
          if (!value?.length) {
            return "--";
          }
          if (value.length === 1) {
            return <BasicCell value={value[0]} tooltipId={tooltipId} />;
          }
          return <PopupCell key={index} docs={value} />;
        },
      },
    ],
    []
  );

  return (
    <ReactTable
      tableTheme="casesTableTheme"
      columns={columns}
      data={records}
      NoDataComponent={NoData}
      pageSizeOptions={[10, 25, 50, 100]}
      defaultSortBy={[
        {
          id: "timestamp",
          desc: false,
        },
      ]}
    />
  );
}

export default CaseRecordsTable;
